import React from 'react';
import { AllocationPlanSection } from './AllocationPlanSection';
import { ProcessedPlanData } from './PlanQueue.types';
import styles from './PlanQueue.styles';
import { Typography } from '@material-ui/core';

interface AllocationPlanTabProps {
  hasError: boolean;
  /** The data count, passed in to not 'reprocess' the data for counting */
  count: number;
  data: ProcessedPlanData;
  search: string;
  onSearchChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

function AllocationPlanQueueError() {
  return (
    <div className={styles.errorContainer}>
      <span className={styles.errorMessage}>⚠️ Cannot Fetch Allocation Plan Queue</span>
    </div>
  );
}

export const AllocationPlanTab = ({ hasError, count, data, search, onSearchChange }: AllocationPlanTabProps) => {
  const { processing, completed, failed } = data;
  const noData = count === 0;
  return hasError ? (
    <AllocationPlanQueueError />
  ) : (
    <div>
      <div className={styles.searchContainer}>
        <input type="text" placeholder="Search item by description" value={search} onChange={onSearchChange} />
      </div>
      <section className={styles.itemsContainer}>
        {/* FIXME: do we want this on all tabs or not at all? It's leftover from the original alloc plan queue layout */}
        {noData ? (
          <div style={{ display: 'flex', minHeight: 60, alignItems: 'center', justifyContent: 'center' }}>
            <Typography variant="subtitle2">No allocation plan updates</Typography>
          </div>
        ) : (
          <React.Fragment>
            <AllocationPlanSection
              items={processing.items}
              sectionName={'Processing'}
              componentType={{ variant: 'caption' }}
              badgeColor={processing.badgeColor}
            />
            <AllocationPlanSection
              items={completed.items}
              sectionName={'Completed'}
              componentType={{ variant: 'caption' }}
              badgeColor={completed.badgeColor}
            />
            <AllocationPlanSection
              items={failed.items}
              sectionName={'Failed'}
              componentType={{ variant: 'caption' }}
              badgeColor={failed.badgeColor}
            />
          </React.Fragment>
        )}
      </section>
    </div>
  );
};
